<template>
    <svg viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg">
        <circle class="fill-gray-300" cx="20.5" cy="20" r="20" />
        <path class="stroke-white" d="M12 20h17" stroke-linecap="round" stroke-width="3" />
    </svg>
</template>
